require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-multilateral-development-banks-continue-to-fund-fossils.json") })
        }
      }, "path---en-us-update-multilateral-development-banks-continue-to-fund-fossils");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-multilateral-development-banks-continue-to-fund-fossils!./.cache/json/en-us-update-multilateral-development-banks-continue-to-fund-fossils.json
// module id = 776
// module chunks = 231608221292675